import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class EmpresaParametrizacaoValidation extends DefaultValidation {
	validate(model, refs) {
		let validated = true;

		if (Util.isNull(model.valordecimalplaces)) {
			refs.decimalPlacesInput.focusedOut = true;
			validated = false;
		}

		if (Util.isNull(model.qtdedecimalplaces)) {
			refs.qtdeDecimalPlacesInput.focusedOut = true;
			validated = false;
		}

		if (model.img_conexao_tipo.id == 1) {
			if(Util.isNull(model.img_host) || !Util.validateURL(model.img_host) || !Util.validateDominioURL(model.img_host)) {
				refs.urlCatalagoInput.focusedOut = true;
				validated = false;
			}

		} else if (model.img_conexao_tipo.id == 0) {
			if (Util.isNull(model.img_host) || !Util.validateFTP(model.img_host) || !Util.validateDominioURL(model.img_host)) {
				refs.urlCatalagoInput.focusedOut = true;
				validated = false;
			}

			if (Util.isNull(model.img_ftp_port)) {
				refs.ftpPortaInput.focusedOut = true;
				validated = false;
			}
	
			if (Util.isNull(model.img_ftp_user)) {
				refs.ftpUsuarioInput.focusedOut = true;
				validated = false;
			}
	
			if (Util.isNull(model.img_ftp_pwd)) {
				refs.ftpSenhaInput.focusedOut = true;
				validated = false;
			}
	
			if (Util.isNull(model.img_ftp_dir)) {
				refs.ftpDiretorioInput.focusedOut = true;
				validated = false;
			}
		}
			
		return validated;
	}
}
